import { NgModule } from '@angular/core';
import { RightViewComponent } from './rightview/rightview.component';
import { CardModule, DropdownModule, FormModule, IconModule, TagModule } from '@giglio-com/ng-libraries/dist';
import { OrderGridComponent } from './ordergrid/ordergrid.component';
import { CommonModule } from '@angular/common';
import { BottomViewComponent } from './bottomview/bottomview.component';
import { MessageComponent } from './message/message.component';
import { CustomIconComponent } from './icon/icon.component';
import { OrderPreviewComponent } from './order-preview/order-preview.component';

@NgModule({
  imports: [TagModule, FormModule, CardModule, IconModule, CommonModule, DropdownModule],
  declarations: [
    RightViewComponent,
    OrderGridComponent,
    BottomViewComponent,
    MessageComponent,
    CustomIconComponent,
    OrderPreviewComponent,
  ],
  exports: [
    RightViewComponent,
    OrderGridComponent,
    BottomViewComponent,
    MessageComponent,
    CustomIconComponent,
    OrderPreviewComponent,
  ],
})
export class ComponentsModule {}
